module.exports = __webpack_public_path__ + "static/media/ly.b180a3a1.svg";